<ion-app>
  <app-navigation-progress />
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<app-logout-overlay />
